import { useEffect } from "react";
import { TextPage, TextSection } from "@/components/TextPage";

export default function PrivacyPage() {
  useEffect(() => {
    document.title = "Privacy Policy — Findora";
  }, []);

  return (
    <TextPage
      testId="privacy-page"
      eyebrow="Your data"
      title="Privacy Policy"
      note="Last updated: September 7, 2026"
    >
      <TextSection testId="privacy-intro">
        <p>
          This policy explains what information Bayborn Consulting Inc.
          (operating this site under the name Findora) collects from visitors to
          this site and how it's used.
        </p>
      </TextSection>

      <TextSection title="Information we collect" testId="privacy-information-collected">
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Basic technical data collected automatically by our hosting provider
            (such as IP address, browser type, and pages viewed), used only for
            site operation and security.
          </li>
          <li>
            Information you provide directly, such as through a contact form or
            email, if one is added later.
          </li>
          <li>
            We do not collect payment or account information — all purchases
            happen on the third-party marketplace (currently Amazon) you're
            redirected to.
          </li>
        </ul>
      </TextSection>

      <TextSection title="Cookies and tracking" testId="privacy-cookies">
        <p>
          This site does not currently use Google Analytics or any other
          analytics or advertising cookies. If that changes, this section will
          be updated first to describe what's added and how to opt out, before
          it's switched on.
        </p>
        <p>
          Third-party sites you're linked to, including Amazon, set their own
          cookies for affiliate tracking and are governed by their own privacy
          policies, not this one.
        </p>
      </TextSection>

      <TextSection title="How information is used" testId="privacy-usage">
        <p>
          Any data collected is used only to understand how the site is used and
          to improve it. It is not sold to third parties.
        </p>
      </TextSection>

      <TextSection title="Your choices" testId="privacy-choices">
        <p>
          You can use your browser's settings to block cookies. Doing so may
          affect how well the site works.
        </p>
      </TextSection>

      <TextSection title="Contact" testId="privacy-contact">
        <p>
          Questions about this policy can be sent to{" "}
          <a
            data-testid="privacy-contact-email"
            href="mailto:adayodeji@yahoo.co.uk"
            className="text-brass underline underline-offset-4 hover:text-brass-hover"
          >
            adayodeji@yahoo.co.uk
          </a>
          .
        </p>
      </TextSection>
    </TextPage>
  );
}
